import React from 'react';
import { View, TouchableOpacity, Image, StyleSheet } from 'react-native';
// Custom
import c, { globalStyles } from '../styles/_colors';
import { PnmacTextMobile } from '../Typography';
var leftIcons = {
  chevronDown: require('../assets/icon-chevron-down.png'),
  chevronUp: require('../assets/icon-chevron-up.png'),
  pencil: require('../assets/icon-pencil.png'),
  cross: require('../assets/icon-cross.png')
};
var rightIcons = {
  arrow: require('../assets/icon-arrow-right-20.png')
};
var CardButtonRow = function (props) {
  var realChildren = React.Children.toArray(props.children);
  var children = realChildren.map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      first: index === 0
    });
  });
  return /*#__PURE__*/React.createElement(View, {
    style: [s.cardButtonRow, props.style]
  }, children);
};
var CardButton = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: s.cardButton
  }, props.first ? null : /*#__PURE__*/React.createElement(View, {
    style: s.divider
  }), /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: props.onPress,
    activeOpacity: 0.5
  }, /*#__PURE__*/React.createElement(View, {
    style: props.innerButtonStyles || s.cardButtonInner
  }, props.icon && leftIcons[props.icon] && /*#__PURE__*/React.createElement(Image, {
    source: leftIcons[props.icon],
    style: s.icon(props)
  }), /*#__PURE__*/React.createElement(PnmacTextMobile, {
    gilroy: true,
    size: globalStyles.width < 375 ? 13 : 15,
    style: s.text(props)
  }, props.text), props.icon && rightIcons[props.icon] && /*#__PURE__*/React.createElement(Image, {
    source: rightIcons[props.icon],
    style: s.icon(props)
  }))));
};
CardButtonRow.Button = CardButton;
export default CardButtonRow;
var s = {
  cardButtonRow: {
    flexDirection: 'row',
    borderTopColor: c.lighterGray,
    borderTopWidth: StyleSheet.hairlineWidth
  },
  cardButton: {
    flex: 1
  },
  cardButtonInner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 16,
    flexDirection: 'row'
  },
  divider: {
    position: 'absolute',
    top: 7,
    bottom: 7,
    left: 0,
    width: StyleSheet.hairlineWidth,
    backgroundColor: c.lighterGray
  },
  icon: function (props) {
    var _a;
    return _a = {
      width: props.icon === 'pencil' ? 14 : props.icon === 'cross' ? 10 : 12,
      height: props.icon === 'pencil' ? 14 : props.icon === 'cross' ? 10 : 8
    }, _a[leftIcons[props.icon] ? 'marginRight' : 'marginLeft'] = globalStyles.width < 375 ? 6 : 9, _a.tintColor = props.color || c.darkCyan, _a;
  },
  text: function (props) {
    return {
      color: props.color || c.darkCyan
    };
  }
};